import { getCoreAjax } from '../../utils/moodle-amd';

export default async () => {
  const modBoard = document.querySelector('.mod_board');
  if (!modBoard) return;

  const boardData = await get_board();
  const myratednoteids = boardData?.[0]?.myratednoteids || [];

  const attachRatingWatchers = (ratings) => {
    ratings.forEach((rating) => {
      // Avoid attaching observers multiple times
      if (rating.dataset.ratingObserved === '1') return;
      rating.dataset.ratingObserved = '1';

      let syncCount = 0;
      const sync = () => {
        if (syncCount === 0) {
          rating.dataset.origrating = (rating.textContent || '').trim();
        }

        rating.dataset.rating = (rating.textContent || '').trim();

        if (rating.dataset.origrating !== rating.dataset.rating) {
          rating.dataset.myrated = 'true';
        }

        const board_note = rating.closest('.board_note');
        const noteid = board_note?.dataset?.ident;
        if (myratednoteids.includes(Number(noteid))) {
          rating.dataset.myrated = 'true';
        }

        syncCount++;
      };

      // Initial sync
      sync();

      // Watch for text changes inside the rating element
      const textObserver = new MutationObserver(() => sync());

      textObserver.observe(rating, {
        characterData: true,
        childList: true,
        subtree: true
      });

      // Store observer so you can disconnect later if needed
      rating._ratingObserver = textObserver;
    });
  };

  const checkForRatings = () => {
    const ratings = modBoard.querySelectorAll('.mod_board_rating');
    if (!ratings.length) return false;

    attachRatingWatchers(ratings);
    return true;
  };

  // If already present, set up immediately
  if (checkForRatings()) return;

  // Otherwise observe until they appear, then set up and stop
  const observer = new MutationObserver((_, obs) => {
    if (checkForRatings()) obs.disconnect();
  });

  observer.observe(modBoard, {
    childList: true,
    subtree: true
  });

  async function get_board() {
    try {
      const Ajax = await getCoreAjax();

      const userid =
        document.querySelector('#usernavigation *')?.dataset?.userid || 0;

      const cmid = Number(
        document.body.className.match(/\bcmid-(\d+)\b/)?.[1] || 0
      );

      if (!cmid) {
        console.warn('CMID not found');
        return null;
      }

      const response = await Ajax.call([
        {
          methodname: 'mod_board_get_board',
          args: {
            id: '-1',
            cmid,
            ownerid: Number(userid)
          }
        }
      ])[0];

      return response;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
};
